const setCSSVariables = (theme) => {
    const root = document.documentElement;
  
    root.style.setProperty('--primary-main', theme.palette.primary.main);
    root.style.setProperty('--secondary-main', theme.palette.secondary.main);
    root.style.setProperty('--success-main', theme.palette.success.main);
    root.style.setProperty('--white-main', theme.palette.white.main);
    root.style.setProperty('--warning-main', theme.palette.warning.main);
    root.style.setProperty('--font-family', theme.typography.fontFamily);
  };
  
  export default setCSSVariables;